import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const projectsSlice = createAppSlice({
  name: 'projects',
  initialState,
  reducers,
});

export const {
  loadProjects,
  loadProjectsListForSeries,
  loadProjectsList,
  loadProjectGroups,
  setGetProjectOptions,
  setGetProjectListForSeriesOptions,
  setProjectToDelete,
  setProjectToEdit,
  setProjectsDisplayView,
  deleteProject,
  duplicateProject,
  setSelectedProjectGroup,
  updateProjectGroup,
  deleteProjectGroup,
  createProjectGroup,
  setAddProjectsToGroup,
  clearGroupError,
  addProjectsToGroup,
  clearProjects,
  setGroupToDelete,
  setGroupToEdit,
  setShowCreateGroupModal,
  loadProjectGroupTree,
  modifyProjectGroupsForAdmin,
} = projectsSlice.actions;

export default projectsSlice.reducer;
